"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _componentUtils = _interopRequireDefault(require("./component-utils"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var InnerComponent = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(InnerComponent, _React$PureComponent);

  var _super = _createSuper(InnerComponent);

  function InnerComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, InnerComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (name, value) {
      var _this$props = _this.props,
          on = _this$props.on,
          component = _this$props.component; // Generic handler

      if (on) {
        on({
          name,
          value,
          component
        });
      } // Handler for specific event


      var handlerName = 'on' + name.charAt(0).toUpperCase() + name.slice(1);

      if (_this.props[handlerName]) {
        _this.props[handlerName]({
          value,
          component
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(InnerComponent, [{
    key: "addChangeListener",
    value: function addChangeListener() {
      this.props.component.on('$change', this.handleChange); // Emit a mount event so that the component can load any initial data, etc... We emit this event
      // here and not in componentDidMount() as the component may actually be set after
      // componentDidMount() was run.

      this.props.component.emitChange('mount');
    }
  }, {
    key: "removeChangeListener",
    value: function removeChangeListener() {
      this.props.component.removeListener('$change', this.handleChange);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.component) {
        this.addChangeListener();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Emit a unmount event so that we can perform any needed clean up
      this.props.component.emitChange('unmount');
      this.removeChangeListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Is the component changing?
      if (this.props.component !== prevProps.component) {
        // Recreate the listener
        this.removeChangeListener();
        this.addChangeListener();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          component = _this$props2.component,
          others = (0, _objectWithoutProperties2.default)(_this$props2, ["component"]);

      if (component) {
        var Component = _componentUtils.default.getUIComponent(component);

        return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
          component: component
        }, others));
      } else {
        return null;
      }
    }
  }]);
  return InnerComponent;
}(_react.default.PureComponent);

exports.default = InnerComponent;